import { Business } from '../business';

export interface OwnershipGroup {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  businesses?: Business[];
}

export const exampleOwnershipGroup: OwnershipGroup = {
  id: 1,
  name: 'Example Ownership Group',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  businesses: [],
};
